import { lazyLoad } from 'utils/lazy';

export const DashboardUser = lazyLoad(
  () => import('./DashboardUser'),
  (m) => m.DashboardUser
);
